<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
              span.white--text  Administración de Movimientos Bancarios
    v-dialog(v-model='dialog', persistent max-width='700px')
      v-container(style='background-color:white !important;max-width: 700px;')
        v-card-title.justify-center
          span.headline Subir movimientos
        div(style="margin-top: 20px;")
          v-flex(xs12, sm12, md12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12, md8)
                v-form(enctype="multipart/form-data")

                  v-text-field(outline label='Selecciona un archivo Excel', @click='pickFile' prepend-inner-icon='attach_file' :value="selectedFileName")
                  input(
                    type="file"
                    style="display: none"
                    ref="file"
                    accept='.xlsx, .xls'
                    @change="onFileChange")
                  
                  v-select(outline
                  :items='bancos'
                  v-model="banco"
                  prepend-inner-icon="description"
                  label="Bancos:")

                  div
                    v-flex(v-if="loading === true", xs12 sm12 md12)
                      v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-progress-circular(indeterminate='', color='primary')
                    v-flex(v-if="loading === false", xs12 sm12 md12)
                      v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                          v-btn(style="background:green;border-radius:10px;", @click.native='save()') Procesar
                          v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-flex(xs12 style='margin-top: 5px;')
          v-btn.mb-2(v-if='cre' @click="dialog = true" style="border-radius:5px;background-color:#d50d10;") Subir Excel
          v-btn.mb-2(@click="descargarFormato()" style="border-radius:5px;background-color:#d50d10;") Descargar Formato
        v-flex(xs12 style='margin-top: 5px;')
          v-layout(wrap style='justify-content: space-between;')
            v-flex(xs3)
              v-text-field(v-model='search', label='Buscar')
            v-flex(xs3 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:disabled="resultadosres.length == 0" :items='filtros' v-model="seleccionFiltro" label="Estatus" @change='cambiarFiltro()')
            v-flex(xs3 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:disabled="resultadosres.length == 0" :items='bancosF' v-model="seleccionFiltroB" label="Bancos" @change='cambiarFiltroB()')
            v-flex(xs2 style='display: flex;align-items: center;justify-content: flex-end;')
              v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(v-model='dateRangeText' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' v-on='on')
                v-date-picker(multiple v-model='dates' no-title='' dark='')
                  v-spacer
                  v-btn(text='' color='primary' @click='$refs.menu1.save(dates)')
                    | OK
              v-btn.mx-0(icon @click='buscarFecha' style='background: white;border-radius: 100%;margin-left:10px !important;').elevation-4
                v-icon(color='#d50d10' style='font-size: 1.70rem;') search
            v-flex(xs1 style='display: flex;align-items: center;justify-content: center;')
              vue-excel-xlsx( v-if='resultados && resultados.length > 0' :data='dataExcel' :columns='columnsExcel' :filename="'Safiro-Movimientos'" :sheetname="'sheetname'")
                div(style='display: flex;flex-direction: column;font-size: 12px;font-weight: bold;text-align: center;')
                  img(src='../assets/iconos/excel.png', style='height: 60px;width: auto;')
                  span Movimientos
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Movimientos
        v-data-table.elevation-1(:headers='headers' :pagination.sync="pagination" :search='search' :items="resultados" style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ transform(props.item.fechaC)}}
            td {{ transform(props.item.fecha)}}
            td {{ props.item.descripcion }}
            td(v-if="props.item.banco && props.item.banco.nombre") {{ props.item.banco.nombre }}
            td(v-else) N/A
            td {{ props.item.monto }}
            td {{ props.item.referencia }}
            td {{ props.item.estatus }}
            td(v-if='props.item.cobro && props.item.cobro.nro') {{ props.item.cobro.nro }}
            td(v-else) N/A
            td
              v-btn.mx-0(v-if='elm && props.item.estatus == "Pendiente"' icon, @click='deleteItem(props.item)')
                  v-icon(color='pink') delete
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import readXlsxFile from 'read-excel-file'
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
export default {
  name: "Movimientos",
  data: vm => ({
    ruta: serverImg,
    dates: [],
    data: [],
    dataExcel: [],
    columnsExcel: [
      {
        label: "Fecha Creación",
        field: "fechaC",
      },
      {
        label: "Fecha Movimiento",
        field: "fecha",
      },
      {
        label: "Cobro",
        field: "nro",
      },
      {
        label: "Descripcion",
        field: "descripcion",
      },
      {
        label: "Banco",
        field: "banco",
      },
      {
        label: "Monto",
        field: "monto",
      },
      {
        label: "Referencia",
        field: "referencia",
      },
      {
        label: "Estatus",
        field: "estatus",
      },
    ],
    loading: false,
    dialog4: false,
    selectedFileName: null,
    bancos:[],
    bancosF:[],
    banco: "",
    seleccionFiltro: 'todos',
    seleccionFiltroB: 'Todos',
    filtros: [
      {
        text: "Todos",
        value: "todos"
      },
      {
        text: "Pendientes",
        value: "Pendiente"
      },
      {
        text: "Conciliados",
        value: "Conciliado"
      },
    ],
    pagination: {
      sortBy: 'fecha', // The field that you're sorting by
      descending: true
    },
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    modal: false,
    search: "",
    form: {
      _id: "",
      fecha: "",
      descripcion: "",
      banco: "",
      monto: "",
      referencia: "",
      estatus: ""
    },
    dialog: false,
    resultadosres: [],
    resultados: [],
    headers: [
      { text: "Fecha Creación", value: "fechaC" },
      { text: "Fecha Movimiento", value: "fecha" },
      { text: "Descripción", value: "descripcion" },
      { text: "Banco", value: "banco" },
      { text: "Monto", value: "monto" },
      { text: "Referencia", value: "referencia" },
      { text: "Estatus", value: "estatus" },
      { text: "Cobro", value: "cobro.nro" },
      { text: "Acciones" },
    ],
    defaultForm: {
      _id: "",
      fecha: "",
      descripcion: "",
      banco: "",
      monto: "",
      referencia: "",
      estatus: ""
    },
    cre: "",
    mod: "",
    elm: "",
    img: "",
    valFormat: false,
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    dateRangeText () {
      let todos = []
      let desde
      let hasta
      if (this.dates && this.dates[0])  {
        desde = this.formatDate(this.dates[0])
        todos.push(desde)
      }
      if (this.dates && this.dates[1]) {
        hasta = this.formatDate(this.dates[1])
        todos.push(hasta)
      }
      return todos.join(' ~ ')
    },
  },
  watch: {
    dates (val) {
      if (val && val.length > 2) {
        let res = []
        res.push(val[0])
        res.push(val[2])
        this.$nextTick(() => {
          this.dates = res
        })
      }
      if (val && val.length == 2 && val[0] > val[1]) {
        this.$swal.fire(
          "¡Atención!",
          "La fecha final debe ser mayor a la fecha inicial.",
          "error"
        );
        let res = []
        res.push(val[0])
        this.$nextTick(() => {
          this.dates = res
        })
      }
    },
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  created() {
    let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
    let hasta = this.$moment().format('YYYY-MM-DD')
    this.dates.push(desde)
    this.dates.push(hasta)
    this.verificacion();
    this.initialize();
  },
  methods: {
    deleteItem(item) {
      this.$swal
        .fire({
          title: "¿Estás seguro?",
          text: "No podrás revertir esta operación!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si, Eliminar!"
        })
        .then(result => {
          if (result.value) {
            Api.delete("movimientos/" + item._id)
              .then(res => {
                this.$swal.fire(
                  "Felicidades.!",
                  "Eliminación realizada exitosamente.",
                  "success"
                );
                this.initialize();
              })
              .catch(err => {
                console.error(err);
              });
          }
        });
    },
    pickFile() {
      this.$refs.file.value = ''; // Resetear el input
      this.$refs.file.click();
    },
    onFileChange(event) {
      let file = event.target.files ? event.target.files[0] : null;
      this.selectedFileName = file.name;
      readXlsxFile(file).then((rows) => {
        this.data = [];
        for (let i = 1; i < rows.length; i++) {
          const el = rows[i];
          this.data.push({
            fecha: el[0],
            descripcion: el[1],
            monto: el[2],
            referencia: el[3],
            estatus: 'Pendiente'
          })
        }
      })
    },
    transform(date) {
      return this.$moment(date).utc().format("DD/MM/YYYY")
    },
    aplicarFiltros() {
      let filtroB = this.seleccionFiltroB;
      let filtroE = this.seleccionFiltro;

      // Reiniciar resultados
      this.resultados = [];
      this.dataExcel = [];
      
      // Filtrar resultados
      this.resultados = this.resultadosres.filter(el => {
        const cumpleFiltroB = (filtroB === "Todos" || el.banco._id === filtroB);
        const cumpleFiltroE = (filtroE === "todos" || el.estatus === filtroE);
        return cumpleFiltroB && cumpleFiltroE;
      });
      this.dataExcel = this.resultados.map(item => {
        const el = {
          ...item,
          banco: item.banco ? { ...item.banco } : null,
          cobro: item.cobro ? { ...item.cobro } : null,
        };

        el.banco = (el.banco && el.banco.nombre) ? el.banco.nombre : 'N/A';
        if (el.cobro && el.cobro.nro) {
          el.nro = el.cobro.nro;
        } else {
          el.nro = 'N/A';
        }

        return el;
      });
    },
    cambiarFiltroB() {
      this.aplicarFiltros();
    },
    cambiarFiltro() {
      this.aplicarFiltros();
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminsafiro.permisos.length; i++) {
        if (this.$store.state.adminsafiro.permisos[i].ruta === "Movimientos") {
          for (
            let j = 0;
            j < this.$store.state.adminsafiro.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    buscarFecha() {
      this.dialog4 = true
      let hasta = (this.dates && this.dates[1]) ? this.dates[1] : null
      if (this.dates && this.dates[0]) {
        this.seleccionFiltro = 'todos'
        this.seleccionFiltroB = 'Todos'
        this.resultados = [];
        this.resultadosres = [];
        this.dataExcel = [];
        Api.get("movimientos/admin?desde="+this.dates[0]+'&hasta='+hasta)
        .then(res => {
          this.$nextTick(() => {
            if (res.data && res.data.length > 0) {
              for (let i = 0; i < res.data.length; i++) {
                const el = res.data[i];
                this.resultados.push(el)
                this.resultadosres.push(el)
                if (el.cobro && el.cobro.nro) {
                  el.nro = el.cobro.nro
                } else el.nro = 'N/A'
                this.dataExcel.push({
                  ...el,
                  banco: (el.banco && el.banco.nombre) ? el.banco.nombre : 'N/A'
                })
              }
            }
            this.dialog4 = false
          })
        }).catch(err=>{
          console.log(err)
          this.dialog4 = false
        })
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debes seleccionar al menos una fecha para realizar la operación",
          "error"
        );
      }
    },
   async descargarFormato() {
      try {
        const ExcelJS = require('exceljs');
        // Create a new workbook
        const workbook = new ExcelJS.Workbook();

        // Add a worksheet
        const worksheet = workbook.addWorksheet('Formato Movimientos'); // Nombre más descriptivo

        // Definir columnas para auto-ajustar ancho (opcional, pero útil)
        worksheet.columns = [
          { header: 'FECHA', key: 'fecha', width: 15 },
          { header: 'DESCRIPCION', key: 'descripcion', width: 30 },
          { header: 'MONTO', key: 'monto', width: 15 },
          { header: 'REFERENCIA', key: 'referencia', width: 20 }
        ];

        // Generar el buffer del Excel (en lugar de writeFile)
        const buffer = await workbook.xlsx.writeBuffer();

        // Convertir buffer a Blob
        const blob = new Blob([buffer], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });

        // Crear URL temporal para descarga
        const urlDescarga = window.URL.createObjectURL(blob);

        // Crear enlace dinámico para descarga
        const enlace = document.createElement('a');
        enlace.href = urlDescarga;
        enlace.download = 'formatoMov.xlsx'; // Nombre del archivo descargado
        document.body.appendChild(enlace);
        enlace.click();

        // Limpiar recursos (importante para evitar fugas de memoria)
        document.body.removeChild(enlace);
        window.URL.revokeObjectURL(urlDescarga);

        console.log('Excel descargado exitosamente!');
      } catch (error) {
        console.log(error.message);
        alert('Error al generar el formato Excel. Verifica la consola para más detalles.');
      }
    },
    async initialize() {
      this.date = new Date().toISOString().substr(0, 10)
      this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10))
      this.dates = []
      let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
      let hasta = this.$moment().format('YYYY-MM-DD')
      this.dates.push(desde)
      this.dates.push(hasta)
      this.dialog4 = true;
      this.bancos = []
      this.bancosF = [{text:'Todos', value: 'Todos'}]
      console.log(this.valFormat)
      Api.get(`metodopago/moduloTipo?modulo=CobroApp&tipo=Banco`).then(res => {
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            this.bancos.push({
              text: el.nombre,
              value: el._id,
            })
            this.bancosF.push({
              text: el.nombre,
              value: el._id,
            })
          }
        }
      }).catch(err=>{
        console.log(err)
      });
      Api.get("movimientos/admin?desde="+this.dates[0]+'&hasta='+this.dates[1]).then(res => {
        this.resultados = [];
        this.resultadosres = [];
        this.dataExcel = [];
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            this.resultados.push(el)
            this.resultadosres.push(el)
            if (el.cobro && el.cobro.nro) {
              el.nro = el.cobro.nro
            } else el.nro = 'N/A'
            this.dataExcel.push({
              ...el,
              banco: (el.banco && el.banco.nombre) ? el.banco.nombre : 'N/A'
            })
          }
        }
        this.dialog4 = false;
      }).catch(err=>{
        this.dialog4 = false;
        console.log(err)
      });
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.data = [];
      this.banco = "";
      this.selectedFileName = "";
      this.dialog = false;
    },
    editItem(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog = true;
    },
    save() {
      if (this.banco && this.data && this.data.length > 0) {
        this.data.forEach(el=> {
          el.banco = this.banco
          el.usuario = this.$store.state.adminsafiro._id
        });
        this.dialog4 = true;
        Api.post("movimientos", this.data)
          .then((res) => {
            this.close();
            this.initialize();
            if (res && res.data && res.data.error && res.data.error.length > 0) {
              this.$swal.fire(
                "¡Atención!",
                "Algunas referencias estan duplicadas: "+res.data.error,
                "info"
              );
            } else {
              this.$swal.fire(
                "¡Felicidades!",
                "Modificación realizada exitosamente.",
                "success"
              );
            }
          })
          .catch(err => {
            console.log(err);
            this.dialog4 = false;
            this.$swal.fire(
              "Oops...",
              err.message,
              "error"
            );
        });
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debe ingresar todos los datos solicitados para continuar.",
          "error"
        );
      }
    }
  }
};
</script>
<style lang="scss">
</style>
